// extracted by mini-css-extract-plugin
export default {"dots-container":"style_dots-container__PTFC3","dot":"style_dot__A6V9e","smoothPulse":"style_smoothPulse__zY+yT"};